import React from 'react'
import { CustomCodeSettings, CustomCodeFloatingSettings } from './CustomCodeSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'

export const defaultProps = {
  code: '<p>Hello world!</p>',
}

export const dynamicProps = []

export const CustomCode: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const { code } = blockProps

    const _ = props.renderValue

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-custom-code ${props.className}`}>
        <div dangerouslySetInnerHTML={{ __html: _(code) }}></div>
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

CustomCode.craft = withCraft({
  name: 'CustomCode',
  defaultProps: defaultProps,
  settings: CustomCodeSettings,
  floatingSettings: CustomCodeFloatingSettings,
})
